import "./LoadingLines.scss";

import React from "react";

const LoadingLines = (props) => {
    return (<div className="LoadingLinesLoader" style={{marginLeft: '3px'}}>Loading...</div>);
};

export default LoadingLines;